export default "__VITE_ASSET__7cc8fe18__"